import React, { useState } from "react";
import "./BookingForm.scss";
import Input from "../../../components/Input/Input";
import Ticket from "../../../components/Ticket/Ticket";
import sweFlag from "../../../assets/sweFlag.png";
import { BsCheck, BsChevronRight } from "react-icons/bs";
import { CgNotes } from "react-icons/cg";
import { BiCheckCircle } from "react-icons/bi";
import Terms from "../Terms/Terms";
import BookingNotes from "../BookingNotes/BookingNotes";
import { useSelector } from "react-redux";

const BookingForm = (props) => {
  const [toc, setToc] = useState(false);

  const widgetInfo = useSelector((state) => state.widget.widget);

  return (
    <div className="BookingForm" ref={props.refr} onScroll={props.handleScroll}>
      <Ticket staff={props.staff} service={props.service} time={props.time} />
      <div className="form">
        <Input
          label="Förnamn"
          value={props.user.first_name}
          onChange={props.handleFirstNameChange}
          error={props.errors.first_name}
        />
        <Input
          label="Efternamn"
          value={props.user.last_name}
          onChange={props.handleLastNameChange}
          error={props.errors.last_name}
        />
        <Input
          label="Email"
          type="email"
          value={props.user.email}
          onChange={props.handleEmailChange}
          error={props.errors.email}
        />
        <Input
          label="Telefonnummer"
          phone
          value={props.user.phone}
          onChange={props.handlePhoneChange}
          type="tel"
          error={props.errors.phone}
        >
          <div className="phoneInput">
            <img src={sweFlag} alt="Flag" />
            <p>+46</p>
          </div>
        </Input>
        {props.toc && (
          <div className="checkbox">
            <div
              className={"box" + (toc ? " checked" : "")}
              onClick={() => setToc((p) => !p)}
            >
              <BsCheck />
            </div>
            <div className="toc">
              Jag accepterar{" "}
              <span
                onClick={() => props.setTermsOpen(true)}
                style={{
                  color: widgetInfo.company.widget_settings.main_color
                    ? widgetInfo.company.widget_settings.main_color
                    : "#1A73E8",
                  borderColor: widgetInfo.company.widget_settings.main_color
                    ? widgetInfo.company.widget_settings.main_color
                    : "#1A73E8",
                }}
              >
                villkoren.
              </span>
            </div>
          </div>
        )}
        <div
          className={"addBookingNotes" + (props.bookingNotes ? " added" : "")}
          onClick={() => props.setNotesOpen(true)}
        >
          <div className="left">
            <div
              className="notesIcon"
              style={{
                borderColor: !props.bookingNotes
                  ? widgetInfo.company.widget_settings.main_color
                    ? widgetInfo.company.widget_settings.main_color
                    : "#1A73E8"
                  : "#253342",
              }}
            >
              <CgNotes
                style={{
                  color: !props.bookingNotes
                    ? widgetInfo.company.widget_settings.main_color
                      ? widgetInfo.company.widget_settings.main_color
                      : "#1A73E8"
                    : "#253342",
                }}
              />
            </div>
            <p
              style={{
                color: !props.bookingNotes
                  ? widgetInfo.company.widget_settings.main_color
                    ? widgetInfo.company.widget_settings.main_color
                    : "#1A73E8"
                  : "#253342",
              }}
            >
              {props.bookingNotes ? "Notering" : "Lägg till notering"}
            </p>
            {props.bookingNotes && <BiCheckCircle />}
          </div>
          <BsChevronRight />
        </div>
        <div className="cancellation">
          <h4>Avbokningspolicy</h4>
          <h5>
            Avboka gratis senast <b>48 timmar </b> innan.
          </h5>
        </div>
        <div className="btnWrapper">
          <button
            onClick={props.createAppointmentHandler}
            disabled={props.toc ? !toc : false}
          >
            Slutför bokning
          </button>
        </div>
        <div className="formBottom">
          Genom att klicka på "Slutför bokning" accepterar du Bookybooks{" "}
          <span>allmänna villkor.</span>
        </div>
      </div>
      {props.termsOpen && (
        <Terms
          toc={props.toc}
          onSave={() => {
            setToc(true);
            props.setTermsOpen(false);
          }}
        />
      )}
      {props.notesOpen && (
        <BookingNotes
          value={props.bookingNotes}
          onChange={(val) => props.handleBookingNotesChange(val)}
          onSave={() => props.setNotesOpen(false)}
        />
      )}
    </div>
  );
};

export default BookingForm;
